class SizeChart {
    constructor(container = document, options = {}) {
        this.container = container;
        this.modal = this.container.querySelector('#sizeChartModal');
        this.unitToggle = this.container.querySelector('#unitToggle');
        this.tbody = this.container.querySelector('#sizeChartBody');
        this.unit = this.unitToggle?.value || 'cm';

        this.data = {
            tops: [
                { measure: 'Chest', measure_S: 96, measure_M: 100, measure_L: 104, measure_XL: 108 },
                { measure: 'Waist', measure_S: 80, measure_M: 84, measure_L: 88, measure_XL: 92 },
                { measure: 'Hip', measure_S: 98, measure_M: 102, measure_L: 106, measure_XL: 110 },
                { measure: 'ArmLength', measure_S: 64, measure_M: 64, measure_L: 65, measure_XL: 65 },
            ],
            bottoms: [
                { measure: 'Waist', measure_S: 80, measure_M: 84, measure_L: 88, measure_XL: 92 },
                { measure: 'Low Waist', measure_S: 84, measure_M: 88, measure_L: 92, measure_XL: 96 },
                { measure: 'Leg Length', measure_S: 111.7, measure_M: 111.9, measure_L: 112, measure_XL: 112.3 },
                { measure: 'Inseam', measure_S: 84.2, measure_M: 84.6, measure_L: 85, measure_XL: 85.4 },
            ],
        };

        this.data.all = [...this.data.tops, ...this.data.bottoms];

        this.bindEvents(container);
    }

    convertToCm(x) {
        return (x / 2.54).toFixed(1);
    }

    renderMeasureImgs(type) {
        const tops = document.getElementById('size_chart-images-tops');
        const bottoms = document.getElementById('size_chart-images-bottoms');

        if (type == 'tops') {
            tops.style.display = 'block';
            bottoms.style.display = 'none';
        }

        else if (type == 'bottoms') {
            tops.style.display = 'none';
            bottoms.style.display = 'block';
        } else {
            tops.style.display = 'block';
            bottoms.style.display = 'block';
        }
    }

    renderTable(unit = this.unit, productType) {
        if (!this.tbody) return;

        const type = productType;
        let data;

        switch (type) {
            case 'tops':
                data = this.data.tops;
                break;
            case 'bottoms':
                data = this.data.bottoms;
                break;
            default:
                data = this.data.all;
                break;
        }

        this.tbody.innerHTML = '';

        data.forEach(({ measure, measure_S, measure_M, measure_L, measure_XL }) => {
            const s = unit === 'cm' ? measure_S : this.convertToCm(measure_S);
            const m = unit === 'cm' ? measure_M : this.convertToCm(measure_M);
            const l = unit === 'cm' ? measure_L : this.convertToCm(measure_L);
            const xl = unit === 'cm' ? measure_XL : this.convertToCm(measure_XL);

            const row = `<tr>
        <td>${measure}</td>
        <td>${s}</td>
        <td>${m}</td>
        <td>${l}</td>
        <td>${xl}</td>
      </tr>`;
            this.tbody.insertAdjacentHTML('beforeend', row);
        });

        this.container.querySelectorAll('.unit-label').forEach((el) => {
            el.textContent = unit;
        });

        this.renderMeasureImgs(productType);
    }

    open(type) {
        this.productType = type;
        this.modal?.classList.add('active');
        this.renderTable(this.unitToggle?.value || 'cm', type);

        let productDataModal = document.querySelector('quick-add-modal .product.grid');
        if (productDataModal) {
            productDataModal.style.display = 'none';
        }

        let quickAddToggleBtns = document.querySelectorAll('quick-add-modal button.quick-add-modal__toggle');
        if (quickAddToggleBtns) {
            quickAddToggleBtns.forEach((el) => (el.style.display = 'none'));
        }
    }

    close() {
        this.modal?.classList.remove('active');

        let productDataModal = document.querySelector('quick-add-modal .product.grid');
        if (productDataModal) {
            productDataModal.style.display = 'flex';
        }

        let quickAddToggleBtns = document.querySelectorAll('quick-add-modal button.quick-add-modal__toggle');
        if (quickAddToggleBtns) {
            quickAddToggleBtns.forEach((el) => (el.style.display = 'flex'));
        }
    }

    bindEvents() {
        // Open modal
        this.container.querySelectorAll('a[href="#size-chart"]').forEach((button) => {

            button.addEventListener('click', (e) => {
                e.preventDefault();
                this.open(e.target.dataset.type || 'all');
            });
        });

        // Close modal
        this.container.querySelector('#closeSizeChart')?.addEventListener('click', () => this.close());

        // Click outside to close
        this.modal?.addEventListener('click', (e) => {
            if (e.target === this.modal) {
                this.close();
            }
        });

        // Unit toggle
        this.unitToggle?.addEventListener('change', (e) => {
            this.renderTable(e.target.value, this.productType);
        });
    }
}
